import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Input, Select } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { AddWithdrawRequestApi } from '../../../../../api/request/wallet/withdraw.js';

const CashWithdraw = ({ amount, resetAll, details }) => {
  const [form] = Form.useForm();
  const { userDetails } = useSelector(state => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMobile, setSelectedMobile] = useState(null);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const params = {
        userId: userDetails?._id,
        amount: Number(amount),
        withdrawalMethod: 6,
        ...values
      };

      const { data } = await AddWithdrawRequestApi(params);
      if (data?.success) {
        toast.success(data?.message);
        form?.resetFields();
        resetAll();
      }
    } catch (error) {
      if (error?.response?.data?.error?.message)
        toast.error(error?.response?.data?.error?.message);
    } finally {
      setIsLoading(false);
    }
  }

  const mobileOptions = details?.map(mobile => ({ label: mobile, value: mobile, }));

  const handleMobileChange = (mobile) => {
    form.setFieldsValue({ mobileNumber: mobile });
    setSelectedMobile(mobile);
  };

  useEffect(() => {
    if (details && details.length > 0) {
      form.setFieldsValue({ mobileNumber: details[0] });
      setSelectedMobile(details[0]);
    } else {
      form.resetFields();
    }
  }, [details]);

  return (
    <div>
      <Form form={form} layout="vertical" className='space-y-5' onFinish={handleSubmit}>
        <div className="grid sm:grid-cols-2 gap-5">

          {details?.length > 1 && (
            <Form.Item label={<span className="text-lg text-gray-500 font-medium">Select Mobile Number</span>}>
              <Select value={selectedMobile} onChange={handleMobileChange} options={mobileOptions} />
            </Form.Item>
          )}

          <Form.Item
            name="mobileNumber"
            label={<span className="text-lg text-gray-500 font-medium">Mobile Number</span>}
            rules={[{ required: true, message: 'Please enter mobile number' }]}
          >
            <Input placeholder="Mobile Number" size='large' type='number' />
          </Form.Item>
        </div>

        <Form.Item
          name='conditions'
          valuePropName="checked"
          rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
        >
          <Checkbox className='mt-4'>
            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
          </Checkbox>
        </Form.Item>

        <LoadableButton
          className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
          type="submit"
          lable='Submit'
          isLoading={isLoading}
          loadingLable='Adding request...'
        />
      </Form>
    </div>
  )
}

export default CashWithdraw


